import { REDUX_MODAL_TYPES } from './action'

const initialState = {
  assignTo: false,
  ets: null,
  edit: null,
  forDelete: {
    transaction: null,
    onDelete: null
  },
  editHistory: null,
  addContact: null,
  addCost: null,
  companyFlow: null,
  informativeModal: null,
  showingBoxId: -1,
  welcomeModal: null,
  shareLoadBox: false,
  carrierShareBox: false,
  updatePaymentTerms: null
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case REDUX_MODAL_TYPES.ASSIGN_TO:
      return {
        ...state,
        assignTo: action.payload
      }
    case REDUX_MODAL_TYPES.MARKET_PRICE:
      return {
        ...state,
        marketPrice: action.payload
      }
    case REDUX_MODAL_TYPES.ETS:
      return {
        ...state,
        ets: action.payload
      }
    case REDUX_MODAL_TYPES.EDIT_MODAL:
      return {
        ...state,
        edit: action.payload
      }
    case REDUX_MODAL_TYPES.DELETE_MODAL:
      return {
        ...state,
        forDelete: action.payload
      }
    case REDUX_MODAL_TYPES.EDIT_HISTORY:
      return {
        ...state,
        editHistory: action.payload
      }
    case REDUX_MODAL_TYPES.ADD_CONTACT:
      return {
        ...state,
        addContact: action.payload
      }
    case REDUX_MODAL_TYPES.ADD_COST:
      return {
        ...state,
        addCost: action.payload
      }
    case REDUX_MODAL_TYPES.COMPANY_FLOW:
      return {
        ...state,
        companyFlow: action.payload
      }
    case REDUX_MODAL_TYPES.INFORMATIVE_MODAL:
      return {
        ...state,
        informativeModal: action.payload
      }
    case REDUX_MODAL_TYPES.SET_PRICE_BOX_ID:
      return {
        ...state,
        showingBoxId: action.payload
      }
    case REDUX_MODAL_TYPES.WELCOME_MODAL:
      return {
        ...state,
        welcomeModal: action.payload
      }
    case REDUX_MODAL_TYPES.SHARE_LOAD_BOX:
      return {
        ...state,
        shareLoadBox: action.payload
      }
    case REDUX_MODAL_TYPES.CARRIER_SHARE_BOX:
      return {
        ...state,
        carrierShareBox: action.payload
      }
    case REDUX_MODAL_TYPES.UPDATE_PAYMENT_TERMS:
      return {
        ...state,
        updatePaymentTerms: action.payload
      }
    default:
      return state
  }
}
